"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./AgreementItem.module.css"));
var AgreementItem = (function (_super) {
    __extends(AgreementItem, _super);
    function AgreementItem(props) {
        return _super.call(this, props) || this;
    }
    AgreementItem.prototype.render = function () {
        var _a = this.props, title = _a.title, description = _a.description;
        return (react_1.default.createElement("li", { className: styles.condition },
            react_1.default.createElement("span", { className: styles.subtitle }, title),
            react_1.default.createElement("span", null, "  " + description)));
    };
    return AgreementItem;
}(react_1.Component));
exports.AgreementItem = AgreementItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWdyZWVtZW50SXRlbS5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2ludGVsbGl0ZWMvRW5yb2xsZW1udFBhY2tldEluZm9fNF82L3BhcnRzL1NlY3Rpb241L0FncmVlbWVudC9BZ3JlZW1lbnRJdGVtLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXNDO0FBRXRDLGlFQUFvRDtBQVdwRDtJQUFtQyxpQ0FBb0I7SUFDbkQsdUJBQVksS0FBSztlQUNiLGtCQUFNLEtBQUssQ0FBQztJQUNoQixDQUFDO0lBRUQsOEJBQU0sR0FBTjtRQUNVLElBQUEsZUFBaUMsRUFBaEMsZ0JBQUssRUFBRSw0QkFBeUIsQ0FBQTtRQUV2QyxPQUFPLENBQ0gsc0NBQUksU0FBUyxFQUFFLE1BQU0sQ0FBQyxTQUFTO1lBQzNCLHdDQUFNLFNBQVMsRUFBRSxNQUFNLENBQUMsUUFBUSxJQUFHLEtBQUssQ0FBUTtZQUNoRCw0Q0FBTyxPQUFLLFdBQWEsQ0FBUSxDQUNoQyxDQUNSLENBQUE7SUFDTCxDQUFDO0lBQ0wsb0JBQUM7QUFBRCxDQUFDLEFBZkQsQ0FBbUMsaUJBQVMsR0FlM0M7QUFmWSxzQ0FBYSJ9